import { Container } from '@ui/wrapper'
import BoxImage from '@components/box-image/layout-10'
import { SectionWrapper } from './style'

const KompassStrukturierteWertpapiereArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data.items?.map(
          (item) =>
            item && (
              <BoxImage
                key={item.id}
                title={item.title}
                desc={item.description}
                image={item.images[0]}
                path={item.pdfs[0]?.src.localFile.publicURL || item.path}
              />
            )
        )}
      </Container>
    </SectionWrapper>
  )
}

export default KompassStrukturierteWertpapiereArea
